import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import EnumRiskLevel from "@wallet-manager/node-types/dist/types/postgres/const/RiskLevel";

type SweepingParamsRef = {
  limit: string;
  threshold: string;
  decimals: string;
  chain_id: any;
  chain_type: any;
  invokerAddressDictionary: Record<number, { invokerAddress: string }>;
  asset_name: string;
  risk_level: EnumRiskLevel[];
  smart_account_type: SmartAccountType | undefined;
};

const initSweepingParamsRef: SweepingParamsRef = {
  limit: "",
  threshold: "",
  decimals: "",
  chain_id: "",
  chain_type: "",
  invokerAddressDictionary: {},
  asset_name: "",
  risk_level: [],
  smart_account_type: undefined,
};

export { type SweepingParamsRef, initSweepingParamsRef };
